import { ObservedValueOf, of, OperatorFunction, Observable, combineLatest } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { Multi } from "../../../interfaces/multi.interface";
import { Single } from "../../../interfaces/single.interface";


export function NgxMultiToSingle(name:String = null): OperatorFunction<Multi[], Single[]> {

  return map(multis => {

    if (name != null) return multis.find(m => m.name == name)?.series;

    return multis[0]?.series ?? [];
  });
}

